import { COUNTRIES_DATA } from '../../../constant/CountryData';

/**
 * Legacy stored codes that look like ISO-2 but aren't — mapped to the real
 * ISO-3166-1 alpha-2 code the backend's @IsISO31661Alpha2 accepts.
 */
const LEGACY_CODE_ALIASES: Record<string, string> = {
  UK: 'GB',
};

/**
 * Normalize a persisted address country to an ISO-2 code.
 *
 * Records written before the backend gained @IsISO31661Alpha2 validation (or
 * migrated from earlier systems) can hold full names ('New Zealand') or
 * lowercase/aliased codes. Sending those back verbatim 400s the whole details
 * PATCH while the Country combobox renders blank — so resolve what we can and
 * fall back to '' to make the problem visible as a required-field error
 * instead. Two-letter tokens are checked against COUNTRIES_DATA: 'UK' or
 * garbage like 'XX' would pass yup's .required() while rendering a blank
 * combobox and still 400 at the backend.
 */
export const normalizeCountryToIso2 = (country?: string) => {
  const trimmed = country?.trim() ?? '';

  if (!trimmed) return '';

  if (/^[A-Za-z]{2}$/.test(trimmed)) {
    const code = trimmed.toUpperCase();

    if (COUNTRIES_DATA.some((entry) => entry.Id === code)) return code;

    return LEGACY_CODE_ALIASES[code] ?? '';
  }

  const match = COUNTRIES_DATA.find(
    (entry) => entry.Name.toLowerCase() === trimmed.toLowerCase(),
  );

  return match?.Id ?? '';
};
